import { GameEventService } from "../services/GameEventService";
import { Page } from "../enums/Page";
import { TravelMapService } from "../services/TravelMapService";

export class TravelMapComponent extends HTMLElement {
    /** Instance of the game event service */
    private readonly _gameEventService: GameEventService = new GameEventService();
    /** Instance van de TravelMapService */
    private readonly _travelMapService: TravelMapService = new TravelMapService();

    private visitedRooms: string[] = []; // Hier slaan we de bezochte kamers op

    public async connectedCallback(): Promise<void> {
        this.render();
        await this.updateVisitedRooms(); // Roep de functie aan na rendering
    }

    private async updateVisitedRooms(): Promise<void> {
        try {
            this.visitedRooms = await this._travelMapService.getVisitedRooms(); // Haal de bezochte kamers op
            console.log("Bezochte kamers:", this.visitedRooms);

            // Update de zichtbaarheid van de kamers
            this.toggleRoomVisibility();
        }
        catch (error) {
            console.error("Fout bij ophalen van bezochte kamers:", error);
        }
    }

    private toggleRoomVisibility(): void {
        const allRooms: NodeListOf<HTMLElement> = this.querySelectorAll(".room-container");

        allRooms.forEach((room: HTMLElement) => {
            const roomImg: HTMLImageElement = room.querySelector(".clickable") as HTMLImageElement;
            const overlay: HTMLElement = room.querySelector(".overlay") as HTMLElement;
            const roomId: string = roomImg.id;

            if (this.visitedRooms.map(room => room.toLowerCase()).includes(roomId.toLowerCase())) {
                room.classList.remove("hidden");
                overlay.style.display = "none"; // Verberg de overlay
            }
            else {
                room.classList.add("hidden");
                overlay.style.display = "flex"; // Toon de overlay
            }
        });
    }

    private render(): void {
        this.innerHTML = `
            <style>
                #kaartComponent {
                    background-color: rgba(0, 0, 0, 0.6);
                }

                #kaartComponent:before {
                    content: '';
                    position: absolute;
                    top: -10px;
                    left: -10px;
                    right: -10px;
                    bottom: -10px;
                    border: 5px solid rgba(0, 0, 0, 0.2);
                    border-radius: 15px; /* Geverfde rand, lijkt op een papieren rand */
                    z-index: -1; /* Plaatst de rand achter de inhoud */
                }

                .map-container {
                    color: black;
                    padding: 20px;
                    border-radius: 10px;
                    position: relative;
                    overflow: hidden;
                    margin: 50px auto 0; /* Voeg 50px marge toe aan de bovenkant, en zorg ervoor dat de kaart in het midden blijft */
                    box-shadow: inset 0 0 10px rgba(0, 0, 0, 0.15);
                    background: #e1d8b7; /* Lichtgele achtergrondkleur */
                    position: relative; /* Nodig voor de positionering van de verbindingslijnen */
                    background-image:
                        linear-gradient(45deg, rgba(0,0,0,0.1) 25%, transparent 25%),
                        linear-gradient(-45deg, rgba(0,0,0,0.1) 25%, transparent 25%),
                        linear-gradient(45deg, rgba(0,0,0,0.1) 25%, transparent 25%);
                    background-size: 15px 15px;
                    background-position: 0 0, 0 0, 10px 10px;
                    display: grid;
                    grid-template-columns: 1fr 1fr 1fr; /* Drie kolommen */
                    grid-template-rows: auto auto auto auto auto; /* Vijf rijen */
                    gap: 20px; /* Vergroot de ruimte tussen de afbeeldingen */
                    justify-items: center;
                    text-align: center;
                    max-width: 900px;
                    margin: auto;
                }

                .map-container h2 {
                    margin-left: 10px
                }

                .map-container img {
                    cursor: pointer;
                    width: 150px;
                    border: 2px solid transparent;
                    transition: border 0.3s ease-in-out;
                    box-sizing: border-box;
                }

                .map-container img:hover {
                    border: 2px solid #007bff;
                }

                .map-container .full-width {
                    grid-column: span 3; /* Kamer van de Abt neemt de hele breedte in */
                }

                .room-container {
                    position: relative;
                    display: inline-block;
                }

                .room-container img {
                    width: 150px;
                    height: auto;
                    transition: filter 0.3s ease-in-out;
                }

                .room-container .overlay {
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 100%;
                    background-color: rgba(0, 0, 0, 0.5); /* Donkergrijze laag */
                    color: white;
                    font-size: 1rem;
                    font-weight: bold;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    text-transform: uppercase;
                    border-radius: 5px;
                }

                .room-container.hidden img {
                    filter: grayscale(100%) blur(3px) brightness(0.5); /* Kamer is vaag en donker */
                }

                .room-container.hidden .overlay {
                    display: flex; /* Overlay blijft zichtbaar */
                }

                .room-container:not(.hidden) .overlay {
                    display: none; /* Verberg de overlay als de kamer bezocht is */
                }

                .close-button {
                    margin-top: 20px;
                    padding: 10px 20px;
                    background-color: #ff0000;
                    color: white;
                    border: none;
                    border-radius: 5px;
                    cursor: pointer;
                    font-size: 16px;
                }

                .close-button:hover {
                    background-color: #cc0000;
                }
            </style>

            <div id="kaartComponent">
                <div class="map-container">
                    <div class="tekst-container">
                        <h1>Kaart van Rafenstein</h1>
                        <p>Waar wil je naartoe reizen:</p>
                    </div>
                    <!-- Kamer van de Abt bovenaan met volle breedte -->
                    <div class="room-container full-width">
                        <img id="Abtroom" src="/assets/img/rooms/Abtroom.png" alt="Kamer van de Abt" class="clickable">
                        <div class="overlay">Nog niet bezocht</div>
                    </div>

                    <!-- De drie kamers eronder in een rij -->
                    <div class="room-container"><img id="scriptorium" src="/assets/img/rooms/scriptorium.png" alt="Scriptorium" class="clickable"><div class="overlay">Nog niet bezocht</div></div>
                    <div class="room-container"><img id="kloostergang" src="/assets/img/rooms/kloostergangPixel.png" alt="Kloostergang" class="clickable"><div class="overlay">Nog niet bezocht</div></div>
                    <div class="room-container"><img id="Bib" src="/assets/img/rooms/BibAbdij-room.png" alt="Bibliotheek" class="clickable"><div class="overlay">Nog niet bezocht</div></div>

                    <!-- De tweede rij van kamers -->
                    <div class="room-container"><img id="Wichelaar" src="/assets/img/rooms/TorenVanSterrenwichelaar.png" alt="Toren" class="clickable"><div class="overlay">Nog niet bezocht</div></div>
                    <div class="room-container"><img id="Paleis" src="/assets/img/rooms/paleis.png" alt="Paleis" class="clickable"><div class="overlay">Nog niet bezocht</div></div>
                    <div class="room-container"><img id="Marktplein" src="/assets/img/rooms/Marktplein.png" alt="Marktplein" class="clickable"><div class="overlay">Nog niet bezocht</div></div>

                    <!-- De derde rij van kamers -->
                    <div class="room-container"><img id="catacomben" src="/assets/img/rooms/catacomben.png" alt="Catacomben" class="clickable"><div class="overlay">Nog niet bezocht</div></div>
                    <div></div> <!-- Lege ruimte -->
                    <div class="room-container"><img id="Herberg" src="/assets/img/rooms/herberg.png" alt="Herberg" class="clickable"><div class="overlay">Nog niet bezocht</div></div>

                    <!-- De vierde rij van kamers -->
                    <div class="room-container full-width"><img id="Woud" src="/assets/img/rooms/Ruïne-in-het-Woud.png" alt="Ruïne" class="clickable"><div class="overlay">Nog niet bezocht</div></div>
                    <button id="closeMap" class="close-button">Sluiten</button>
                </div>
            </div>
        `;

        // Event listeners voor klikbare afbeeldingen
        this.querySelector("#Abtroom")?.addEventListener("click", this.handleTravel.bind(this, "Abtroom"));
        this.querySelector("#scriptorium")?.addEventListener("click", this.handleTravel.bind(this, "scriptorium"));
        this.querySelector("#kloostergang")?.addEventListener("click", this.handleTravel.bind(this, "kloostergang"));
        this.querySelector("#bibAbdij")?.addEventListener("click", this.handleTravel.bind(this, "bibAbdij"));
        this.querySelector("#Wichelaar")?.addEventListener("click", this.handleTravel.bind(this, "TorenVanSterrenwichelaar"));
        this.querySelector("#Paleis")?.addEventListener("click", this.handleTravel.bind(this, "Paleis"));
        this.querySelector("#Marktplein")?.addEventListener("click", this.handleTravel.bind(this, "Marktplein"));
        this.querySelector("#catacomben")?.addEventListener("click", this.handleTravel.bind(this, "catacomben"));
        this.querySelector("#Herberg")?.addEventListener("click", this.handleTravel.bind(this, "Herbergdeslapenderaaf"));
        this.querySelector("#Woud")?.addEventListener("click", this.handleTravel.bind(this, "Woud"));

        // Event listener voor de sluitknop
        this.querySelector("#closeMap")?.addEventListener("click", this.closeMap.bind(this));
    }

    private async handleTravel(location: string): Promise<void> {
        console.log(`Reizen naar: ${location}`);

        // Roep de TravelMapService aan om te reizen naar de opgegeven locatie
        await this._travelMapService.travelToLocation(location);
        this._gameEventService.switchPage(Page.Canvas); // Verander terug naar de kamer
    }

    private closeMap(): void {
        console.log("Sluit de kaart en ga terug naar de huidige kamer");

        // Verberg het TravelMapComponent in plaats van het verwijderen
        this.style.display = "none"; // Verbergt het component

        // Je kunt ook switchen naar een andere pagina of een andere actie uitvoeren
        this._gameEventService.switchPage(Page.Canvas); // Verander terug naar de kamer
    }
}
